// extracted by mini-css-extract-plugin
export default {"invalid-error":"HullForm_invalid-error__BAInp","subheading":"HullForm_subheading__X6nWH","submitBtn":"HullForm_submitBtn__4pS5B"};